import TextAreaControl from './component'

export default TextAreaControl
